<template>
  <RevContainer>
    <div class="flex items-center justify-between">
      <div class="caption-bold py-8">
        <div class="flex h-full items-center gap-24">
          <RevLink
            v-for="{ label, name, url, icon, classNames } in links"
            :key="name"
            class="flex items-center gap-4"
            data-test="footer-link"
            :to="url"
            :tracking="{ name: name, zone: 'header' }"
            :underlined="false"
          >
            <component
              :is="icon"
              v-if="icon"
              :class="[classNames, 'h-16 w-16']"
            />
            <span :class="classNames">
              {{ label }}
            </span>
          </RevLink>
        </div>
      </div>

      <div class="flex items-center gap-24">
        <CountrySwitchMenu />
      </div>
    </div>
  </RevContainer>
</template>

<script setup lang="ts">
import { RevContainer } from '@ds/components/Container'
import { RevLink } from '@ds/components/Link'

import { useNavLinks } from '../../../composables/useNavLinks'
import CountrySwitchMenu from '../../CountrySwitch/CountrySwitchMenu.vue'

const { links } = useNavLinks({ withTradein: false, variant: 'small' })
</script>
